var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"editor tooltip",style:({
    top: _vm.props.position.y + 'px',
    left: _vm.props.position.x + 'px'
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }